// Simple data-fetching hook with in-memory cache
import { useState, useEffect, useRef } from 'react';

const cache = new Map();

export function useFetch(key, fetcher, deps = []) {
  const [data, setData] = useState(cache.get(key));
  const [loading, setLoading] = useState(!cache.has(key));
  const [error, setError] = useState(null);
  const mounted = useRef(true);

  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);

  useEffect(() => {
    if (!key) return;
    let cancelled = false;
    if (!cache.has(key)) setLoading(true);
    fetcher()
      .then(res => {
        if (cancelled) return;
        cache.set(key, res);
        setData(res);
        setError(null);
      })
      .catch(e => { if (!cancelled) setError(e); })
      .finally(() => { if (!cancelled && mounted.current) setLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error, refetch: () => { cache.delete(key); setLoading(true); fetcher().then(d => { cache.set(key, d); setData(d); setLoading(false); }); } };
}

export function clearCache(prefix) {
  if (!prefix) { cache.clear(); return; }
  for (const k of cache.keys()) if (k.startsWith(prefix)) cache.delete(k);
}
